import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeCloudIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapeCloud" ref={ref} {...props}>
      <path d="M5.7,9.9m12.6,0M5.7,14.1m12.6,0M21.15,12a2.84,2.84,0,0,1-.93,2.1A2.84,2.84,0,0,1,19,19a2.84,2.84,0,0,1-4.87,1.27,2.84,2.84,0,0,1-4.2,0A2.84,2.84,0,0,1,5,19,2.84,2.84,0,0,1,3.77,14.1a2.84,2.84,0,0,1,0-4.2A2.84,2.84,0,0,1,5,5,2.84,2.84,0,0,1,9.9,3.77a2.84,2.84,0,0,1,4.2,0A2.84,2.84,0,0,1,19,5,2.84,2.84,0,0,1,20.22,9.9,2.84,2.84,0,0,1,21.15,12Zm-3.6-2.1a.75.75,0,0,1,.75-.75,1.35,1.35,0,0,0,0-2.7.76.76,0,0,1-.75-.75,1.35,1.35,0,1,0-2.7,0,.75.75,0,1,1-1.5,0,1.35,1.35,0,1,0-2.7,0,.75.75,0,1,1-1.5,0,1.35,1.35,0,1,0-2.7,0,.76.76,0,0,1-.75.75,1.35,1.35,0,1,0,0,2.7.75.75,0,1,1,0,1.5,1.35,1.35,0,1,0,0,2.7.75.75,0,1,1,0,1.5,1.35,1.35,0,1,0,0,2.7.76.76,0,0,1,.75.75,1.35,1.35,0,1,0,2.7,0,.75.75,0,0,1,1.5,0,1.35,1.35,0,1,0,2.7,0,.75.75,0,0,1,1.5,0,1.35,1.35,0,1,0,2.7,0,.76.76,0,0,1,.75-.75,1.35,1.35,0,0,0,0-2.7.75.75,0,0,1,0-1.5,1.35,1.35,0,0,0,0-2.7A.76.76,0,0,1,17.55,9.9Z" />
    </Icon>
  ),
) as IconWithRender;

ShapeCloudIcon.displayName = 'ShapeCloudIcon';
ShapeCloudIcon.renderIcon = (props) => <ShapeCloudIcon {...props} />;
export default ShapeCloudIcon;
